import { CdkDragStart } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { size } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../../../../core/h3ml/state/task-workspace-store';
import { ObjectScopingService } from '../../../../../../core/shared/misc-services/object-scoping.service';
import { ObjectState } from '../../../../../../cross-team-shared/annotation/shared/state/object-state';
import { AnnotationListService } from '../annotation-list/annotation-list.service';
import { ObjectDragAndDropService } from '../annotation-list/object-drag-and-drop.service';

@Component({
  selector: 'h3-object-list',
  templateUrl: './object-list.component.html',
  styleUrls: ['./object-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ObjectListComponent extends DirectiveSuperclass {
  protected taskWorkspaceStore = inject(TaskWorkspaceStore);
  protected dragAndDropService = inject(ObjectDragAndDropService);
  protected objectItems$!: Observable<ObjectState[]>;
  protected selectedObjectCount$ = this.taskWorkspaceStore(
    'objectSelection',
  ).$.pipe(map(size));
  protected draggedItemCanBeDropped$ = this.dragAndDropService.canDrop$();
  protected isDragDisabled =
    this.taskWorkspaceStore.state().readOnly ||
    this.taskWorkspaceStore.isUsingGenAi();
  private objectScopingService = inject(ObjectScopingService);

  private annotationListService = inject(AnnotationListService);

  constructor() {
    super();
    this.objectItems$ = this.annotationListService.getScopedObjects$();
    this.subscribeToTransientInfo();
  }

  dragStart($event: CdkDragStart<ObjectState>) {
    this.dragAndDropService.startObjectDrag($event.source.data.index);
  }

  dragReleased() {
    this.dragAndDropService.dropSelectedObjects();
  }

  isObjectDragged$(objectId: number) {
    return this.dragAndDropService.isObjectDragged$(objectId);
  }

  private subscribeToTransientInfo() {
    // Force annotation list to switch back to root level when currently scoped
    // object becomes filtered out
    this.subscribeTo(
      this.taskWorkspaceStore('objectTransientInfo').$,
      (objectTransients) => {
        const scopedObjectId = this.taskWorkspaceStore.state().scopedObjectId;
        if (
          isDefined(scopedObjectId) &&
          objectTransients[scopedObjectId]?.isFilteredOut
        ) {
          this.objectScopingService.scopeObject(undefined, 'filtered_object');
        }
      },
    );
  }
}
